import { render, staticRenderFns } from "./SecondChild.vue?vue&type=template&id=a5de6a92&scoped=true"
import script from "./SecondChild.vue?vue&type=script&lang=js"
export * from "./SecondChild.vue?vue&type=script&lang=js"
import style0 from "./SecondChild.vue?vue&type=style&index=0&id=a5de6a92&prod&lang=scss&scoped=true"
import style1 from "./SecondChild.vue?vue&type=style&index=1&id=a5de6a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5de6a92",
  null
  
)

export default component.exports